import React, { useState, useMemo } from "react";
import ChoiceContainer from "./ChoiceContainer";
import ComparisonModal from "./ComparisonModal"
import { RETIREMENT_DATA } from "../../../assests/data/results-header-text";
import classes from "./ResultsHeader.module.css";

const ResultsHeader = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBenefitType, setSelectedBenefitType] = useState(null);

  const handleCardClick = (benefitType) => {
    // Do nothing on click, as modal is no longer needed
    // setSelectedBenefitType(benefitType);
    // setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBenefitType(null);
  };

  const retirementData = useMemo(() => RETIREMENT_DATA, []);

  return (
    <div className={classes.main_container}>
      {retirementData.map((data, index) => (
        <ChoiceContainer
          key={index}
          data={data}
          onCardClick={handleCardClick}
        />
      ))}
      <ComparisonModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        benefitType={selectedBenefitType}
      />
    </div>
  );
};

export default React.memo(ResultsHeader);
